<template>
  <section class="grey_bg" aria-labelledby="disclaimer-heading">
    <div class="container mt-4">
      <h1 id="disclaimer-heading" class="display-1 page-title">
        <span class="heading_bdr_btm">
          Disclaimer
        </span>
      </h1>
      <div class="row">
        <div class="col-xs-12 col-md-8 col-md-offset-2">
          <p>
            Investment in securities market are subject to market risks. Read all the related documents carefully before investing.
          </p>
          
          <p>
            Registration granted by SEBI and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.
          </p>

          <p class="mt-3">
            All investments involve risk and the past performance of a security(equities), or financial product does not guarantee future results or returns. Keep in mind that while diversification may help spread risk it does not assure a profit, or protect against loss, in a down market.
          </p>
          <p>
            There is always the potential of losing money when you invest in securities(equities), or other financial products. Investors should consider their investment objectives and risks carefully before investing.
          </p>
          <p>
            A stock having good performance in the past does not guarantee the same in future.
          </p>
          <p>
            Investors must be aware that GROW WITH STOCKS does not give any guarantee or assurance on returns.
          </p>
          <p>
            We believe that the best person to handle your finances is you. By your use of our Services, you're agreeing that you bear responsibility for your financial and investment decisions. You also agree that GROW WITH STOCKS, its directors, it’s research analysts, its employees, and its associates will not be liable for any investment decision made or action taken by you and others based on research report, stock recommendation, news, information, opinion, or any other material published through our Services.
          </p>
          <p>
            As the capital market is affected by many factors/forces such as war, natural calamities, policy changes, government, global markets, price and volume volatility, interest rates, currency exchange rates, taxation laws, political situation, stock exchanges itself, thus the stocks recommended may go up or down depending upon the same.
          </p>
          <p>
            GROW WITH STOCKS, its directors, it’s research analysts its employees, and its associates are neither responsible nor liable for any losses in the client’s portfolio.
          </p>
          <p>
            The stock recommendations given by Grow With Stocks, are given after thorough research on various market factors, fundamentals analysis, and expected performance in the future. However, the stock recommendations given by any of GROW WITH STOCKS employees, research analysts associates, website, should be considered as information and guidance and not as assurance of returns/profits. To invest or buy/sell stocks shall be the sole discretion of the client/reader.
          </p>
          <p>
            We rely on a wide variety of sources, such as Annual Reports, bseindia, moneycontrol etc. We believe these sources of data to be accurate and reliable, but sometimes they may not be. GROW WITH STOCKS makes no claims or representations as to the accuracy, completeness, or truth of any material contained in our areas. Nor is the GROW WITH STOCKS liable for any errors or delays in the content or transmission of the data on our site. The company is not responsible for any losses incurred due to the same. Due to website server failure, cyberfrauds, cybercrime, hacking attack etc, there could be a loss of data. The company shall not be responsible for such an event.
          </p>
          <p>
            Due to factors beyond the company’s control there may be stoppage of services or delay in communications, the company is not responsible for any losses incurred due to the same.
          </p>
          <p>
            You are responsible for your own investment decisions. GROW WITH STOCKS will not be responsible for any errors or omissions in articles or postings, for hyperlinks embedded in messages, or for any results obtained from the use of such information. GROW WITH STOCKS will not be liable for any loss or damage caused by a reader's reliance on information obtained in our area, or in a hyperlinked area. If you don't accept this responsibility for yourself, then you should not use GROW WITH STOCKS services and/or subscription.
          </p>
          <p>
            If you ignore our advice to do independent research of industries, companies, and stocks, choosing instead to trade solely on information, "tips," or opinions found in our blog, social media posts, newsletters etc. you have made a conscious, willing, free, and personal decision to do so. You have also probably made a mistake.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "Disclaimer",
    mounted() {
      document.title = "Disclaimer | Grow With Stocks";
    }
  };
</script>

<style lang="scss" scoped>
  .page-title {
    text-align: center;
    color: #1a1a1a;
    font-weight: 700;
    margin-bottom: 24px;
  }
  .grey_bg {
    background: #f7f7f7;
    padding-bottom: 40px;
  }
  p {
    color: #2d2d2d;
    line-height: 1.6;
  }
  /*==========  Mobile First Method  ==========*/

  /* Custom, iPhone Retina */
  @media only screen and (min-width: 320px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (min-width: 480px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (min-width: 768px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (min-width: 992px) {
  }

  /* Large Devices, Wide Screens */
  @media only screen and (min-width: 1200px) {
  }

  /*==========  Non-Mobile First Method  ==========*/

  /* Large Devices, Wide Screens */
  @media only screen and (max-width: 1200px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (max-width: 768px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (max-width: 480px) {
  }

  /* Custom, iPhone Retina */
  @media only screen and (max-width: 320px) {
  }
</style>



// WEBPACK FOOTER //
// src/views/Disclaimer.vue